import React from 'react'

import ButtonIcons from './components/ButtonIcons'
import * as SC from './styles'

export default function IconButton(props: any) {
   return <SC.Button {...props}>{(ButtonIcons as any)[props.icon]}</SC.Button>
}
